import {gql} from 'graphql-request';
import {useQuery} from '@tanstack/react-query';
import shoppingGraphQLClient from '../services/RegistryShoppingGraphQL/client';

export default function useCategory(id, {skip = false} = {}) {
  const query = gql`
    query getCategory($id: String!) {
      category(id: $id) {
        id
        name
        level
        url
        image {
          url
          altText
        }
        description
        thumbnail {
          url
        }
        breadcrumbs {
          level
          name
          url
        }
        children {
          id
          level
          name
          url
          thumbnail {
            url
          }
        }
        products {
          totalCount
        }
      }
    }
  `;

  const variables = {
    id: id?.toString(),
  };

  return useQuery(
    ['category', id],
    async () => {
      const {category} = await shoppingGraphQLClient.request(query, variables);
      return category;
    },
    {enabled: !skip},
  );
}
